import api from './api';

export const fetchUsers = async () => {
    const response = await api.get('/api/users');
    return response.data;
};

export const createUser = async (userData: any) => {
    const response = await api.post('/api/users', userData);
    return response.data;
};

export const updateUser = async (id: string, userData: any) => {
    const response = await api.put(`/api/users/${id}`, userData);
    return response.data;
};

export const deleteUser = async (id: string) => {
    const response = await api.delete(`/api/users/${id}`);
    return response.data;
};
